<div class="company-ranking">
  <div class="company-ranking__header">
    <span class="company-ranking__header__title">
      {{ 'COMPANY_RANKING.TITLE' | translate }}
    </span>

    <div class="company-ranking__header__page-buttons">
      <div class="company-ranking__header__page-buttons--expanded">
        <mat-slide-toggle (change)="autoRefresh($event)" [checked]="false">
          {{ 'COMPANY_RANKING.AUTO_RELOAD' | translate }}
        </mat-slide-toggle>

        <button
          [disabled]="isLoading"
          (click)="reload()"
          matTooltip="{{ 'COMPANY_RANKING.RELOAD' | translate }}"
          class="company-ranking__header__page-buttons--expanded__button"
        >
          <i class="angularjs-fuse-icon icon-reload company-ranking__header__page-buttons--expanded__button__icon"></i>
        </button>

        <button
          *ngIf="filterStateManagerService.isFilterOn"
          matTooltip="{{ 'COMPANY_RANKING.FILTER_CLEAR' | translate }}"
          [disabled]="isLoading"
          class="company-ranking__header__page-buttons--expanded__button"
          (click)="filterStateManagerService.clearFilters(filter, routeName)"
        >
          <i
            class="angularjs-fuse-icon icon-filter-remove company-ranking__header__page-buttons--expanded__button__icon"
          ></i>
        </button>

        <fc-custom-select
          [label]="'COMPANY_RANKING.CRITERIAS_GROUP' | translate"
          (selectedOptionOutput)="handleOptionSelected($event)"
          (editOptionOutput)="handleEditOption($event)"
          (addOptionOutput)="handleAddOption()"
          [selectedOption]="filterStateManagerService.selectedOption || criteriasGroups[0]"
          [options]="criteriasGroups"
        ></fc-custom-select>
      </div>

      <div class="company-ranking__header__page-buttons--collapsed">
        <button
          class="company-ranking__header__page-buttons--collapsed__arrow-button"
          [matMenuTriggerFor]="menuCompanyComparasion"
        >
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>

        <mat-menu #menuCompanyComparasion>
          <button
            class="company-ranking__header__page-buttons--collapsed__button"
            mat-menu-item
            [disabled]="isLoading"
            (click)="reload()"
          >
            <i class="angularjs-fuse-icon icon-reload"></i>
            <span>{{ 'COMPANY_RANKING.RELOAD' | translate }}</span>
          </button>

          <button
            *ngIf="filterStateManagerService.isFilterOn"
            class="company-ranking__header__page-buttons--collapsed__button"
            mat-menu-item
            [disabled]="isLoading"
            (click)="filterStateManagerService.clearFilters(filter, routeName)"
          >
            <i class="angularjs-fuse-icon icon-filter-remove"></i>
            <span>{{ 'COMPANY_RANKING.FILTER_CLEAR' | translate }}</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </div>

  <filter></filter>

  <ng-container *ngIf="dataTableSource.length && !isLoading">
    <div #content class="company-ranking__content">
      <div class="company-ranking__content__table" tabindex="0">
        <mat-table
          [ngClass]="{ 'is-not-horizontal-scrollable': !isHorizontalScrollableTable }"
          #datatable
          [dataSource]="dataTableSource"
        >
          <ng-container matColumnDef="checkbox" sticky>
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element" class="company-ranking__content__table__criteria-cell--checkbox">
              <div
                class="company-ranking__content__table__criteria-cell--checkbox__wrapper"
                (click)="toggleCompany(element)"
                [ngClass]="{
                  disabled:
                    selectedCompaniesSelection.selected.length === selectedCompaniesLimit &&
                    !selectedCompaniesSelection.isSelected(element.id)
                }"
                [matTooltip]="
                  selectedCompaniesSelection.selected.length === selectedCompaniesLimit
                    ? ('COMPANY_RANKING.LIMIT_EXCEEDED' | translate)
                    : null
                "
                [matTooltipDisabled]="
                  selectedCompanies.length < selectedCompaniesLimit || selectedCompaniesSelection.isSelected(element.id)
                "
              >
                <mat-checkbox
                  [checked]="selectedCompaniesSelection.isSelected(element.id)"
                  [ngClass]="{
                    disabled:
                      selectedCompaniesSelection.selected.length === selectedCompaniesLimit &&
                      !selectedCompaniesSelection.isSelected(element.id)
                  }"
                >
                </mat-checkbox>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="position" sticky>
            <th class="company-ranking__content__table__criteria-header--index" mat-header-cell *matHeaderCellDef>
              <span>#</span>
            </th>
            <td
              mat-cell
              *matCellDef="let element; let i = index"
              class="company-ranking__content__table__criteria-cell--index"
            >
              <span>{{ i + 1 }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="name" sticky>
            <th
              mat-header-cell
              (click)="orderByPoints()"
              *matHeaderCellDef
              class="company-ranking__content__table__criteria-header"
            >
              <div class="company-ranking__content__table__criteria-header--company">
                <span>{{ 'COMPANY_RANKING.COMPANY' | translate }}</span>
                <mat-icon *ngIf="sortDirection === 'desc'">arrow_downward</mat-icon>
                <mat-icon *ngIf="sortDirection === 'asc'">arrow_upward</mat-icon>
              </div>
            </th>
            <td mat-cell *matCellDef="let element" class="company-ranking__content__table__criteria-cell">
              <div class="company-ranking__content__table__criteria-cell--company">
                <img
                  *ngIf="element.avatarUrl"
                  [src]="element.avatarUrl"
                  [alt]="element.name"
                  (error)="element.avatarUrl = null"
                  class="company-ranking__content__table__criteria-cell--company__avatarUrl"
                />
                <div *ngIf="!element.avatarUrl">
                  <img
                    src="assets/images/icons/mdi_office-building.svg"
                    [alt]="element.name"
                    class="company-ranking__content__table__criteria-cell--company__avatarUrl"
                  />
                </div>
                <div class="company-ranking__content__table__criteria-cell--company__text p-[8px]">
                  <span class="company-ranking__content__table__criteria-cell--company__text__name">
                    {{ element.name }}
                  </span>
                  <span class="flex gap[8px]">
                    {{ ('COMPANY_RANKING.POINTS' | translate) + ': ' }}
                    <span class="company-ranking__content__table__criteria-cell--company__text__total-points">
                      {{ roundResult(element.totalPoints) }}
                    </span>
                  </span>
                  <span class="flex gap[8px]">
                    {{ ('COMPANY_RANKING.DISCOUNT' | translate) + ': ' }}
                    <span class="company-ranking__content__table__criteria-cell--company__text__total-discount">
                      {{ roundResult(element.totalDiscount) + '%' }}
                    </span>
                  </span>
                </div>
              </div>
            </td>
          </ng-container>

          <ng-container *ngFor="let criteriaKey of criteriaKeys; let i = index">
            <ng-container matColumnDef="{{ criteriaKey }}">
              <th class="company-ranking__content__table__criteria-header" mat-header-cell *matHeaderCellDef>
                <span class="company-ranking__content__table__criteria-header__info__content__criteria">
                  {{ 'COMPANY_RANKING.CRITERIA_NUMBER' | translate: { number: i + 1 } }}
                </span>
                <span class="company-ranking__content__table__criteria-header__info__content__name">
                  {{
                    'COMPANY_RANKING.CRITERIAS.' + (getRuleNameByCriteriaId(criteriaKey) | changeCase: 'constantCase')
                      | translate
                  }}
                </span>
              </th>
              <td class="company-ranking__content__table__criteria-cell" mat-cell *matCellDef="let element">
                <div>
                  <span class="company-ranking__content__table__criteria-cell__value">
                    <ng-container *ngIf="isPercentage.includes(element.criterias[criteriaKey].ruleName)">
                      {{ roundResult(element.criterias[criteriaKey].value) + '%' }}
                    </ng-container>
                    <ng-container *ngIf="isTimeAverage.includes(element.criterias[criteriaKey].ruleName)">
                      {{ element.criterias[criteriaKey].value | formatDuration: 'days' }}
                    </ng-container>
                    <ng-container *ngIf="isTimeAverageInSeconds.includes(element.criterias[criteriaKey].ruleName)">
                      {{ element.criterias[criteriaKey].value | formatDuration: 'seconds' }}
                    </ng-container>
                    <ng-container *ngIf="element.criterias[criteriaKey].ruleName === 'averageRating'">
                      {{ element.criterias[criteriaKey].value + ' ' + ('COMPANY_RANKING.STARTS' | translate) }}
                    </ng-container>
                  </span>
                  <span class="company-ranking__content__table__criteria-cell__separator">|</span>
                  <span class="company-ranking__content__table__criteria-cell__points">
                    {{ roundResult(element.criterias[criteriaKey].points) }} {{ 'COMPANY_RANKING.POINTS' | translate }}
                  </span>
                </div>
                <div>
                  {{ 'COMPANY_RANKING.DISCOUNT' | translate }}:
                  <span class="company-ranking__content__table__criteria-cell__discount">
                    {{ element.criterias[criteriaKey].discount }}%
                  </span>
                </div>
              </td>
            </ng-container>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </mat-table>
      </div>
    </div>

    <div *ngIf="selectedCompanies.length" class="company-ranking__selected-companies">
      <div class="company-ranking__selected-companies__companies">
        <div
          *ngFor="let selectedCompany of selectedCompanies"
          class="company-ranking__selected-companies__companies__company"
        >
          <img
            *ngIf="selectedCompany.avatarUrl"
            [src]="selectedCompany.avatarUrl"
            [alt]="selectedCompany.name"
            (error)="element.avatarUrl = null"
            class="company-ranking__selected-companies__companies__company__logo"
          />
          <div *ngIf="!selectedCompany.avatarUrl">
            <img
              src="assets/images/icons/mdi_office-building.svg"
              [alt]="selectedCompany.name"
              class="company-ranking__selected-companies__companies__company__logo"
            />
          </div>
          <span class="company-ranking__selected-companies__companies__company__name">
            {{ selectedCompany.name }}
          </span>
        </div>
      </div>
      <button
        (click)="compareComapanies(selectedCompanies)"
        class="company-ranking__selected-companies__compare-button"
      >
        {{
          'COMPANY_RANKING.SELECTED_COMPANIES.BUTTON'
            | translate
              : { selectedCompaniesQuantity: selectedCompanies.length, selectedCompaniesLimit: selectedCompaniesLimit }
        }}
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="isLoading">
    <div class="company-ranking__loading">
      <mat-spinner color="primary" diameter="64" class="mb-24"></mat-spinner>
      <span>{{ 'COMPANY_RANKING.LOADING' | translate }}</span>
    </div>
  </ng-container>

  <ng-container *ngIf="!dataTableSource.length && !isLoading">
    <div class="company-ranking__no-data">
      <mat-icon class="company-ranking__no-data__icon">search</mat-icon>
      <span class="company-ranking__no-data__description">{{ 'COMPANY_RANKING.NO_DATA' | translate }}</span>
    </div>
  </ng-container>
</div>
